import { FC } from "react";
import { Tooltip } from "antd";
import { SvgIcon } from "../../../../common/components/SvgIcon";
import { EconomicFactors as EconomicFactorsType } from "../../../../types/IntelligenceTypes";
import { GenericCard } from "../../../../common/components/GenericCard";
import styles from "./EconomicFactors.module.less";

function getRiskClass(risk?: string) {
    switch (risk) {
        case "high":
            return styles.riskHigh;
        case "low":
            return styles.riskLow;
        case "medium":
            return styles.riskMedium;
        default:
            return styles.riskMedium;
    }
}

interface EconomicFactorsProps {
    data?: EconomicFactorsType;
}

export const EconomicFactors: FC<EconomicFactorsProps> = ({ data }) => {
    const riskTypeClass = getRiskClass(data?.riskLevel);
    const points = data?.factors.concat(data.regionalInsights);
    const risk = data?.riskLevel ? `${data.riskLevel} Risk` : "--";

    return (
        <GenericCard size="larger" className={styles.card}>
            <div className={styles.content}>
                <div className={styles.titleRow}>
                    <div className={styles.title}>Economic and geopolitical factors</div>
                    <Tooltip title="This metric assesses the impact of broader economic and geopolitical conditions on vendor's business operations and strategic decisions. Understanding these factors helps in navigating market uncertainties and capitalizing on opportunities.">
                        <SvgIcon name="help" size={12} color="#1890FF" />
                    </Tooltip>
                </div>
                <div className={styles.contentMain}>
                    <div className={`${styles.risk} ${riskTypeClass}`}>{risk}</div>
                </div>
                <ul className={styles.points}>{points?.map((p) => <li key={p}>{p}</li>)}</ul>
            </div>
        </GenericCard>
    );
};
